<template>
  <div>
    <el-alert title="主线程压缩时大文件会卡住，需要控制文件大小，如需要压缩大文件建议使用 web worker" type="success" :closable="false">
    </el-alert>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="12" style="margin: 10px 0;">
        <el-upload class="upload-demo" drag :multiple="false" :http-request="uploadImg" :show-file-list="false" action="/"
          accept=".png">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传 png 文件</div>
        </el-upload>
      </el-col>
      <el-col :xs="24" :sm="12" style="margin: 10px 0;">
        <el-row :gutter="10" v-loading="compressing">
          <el-col :span="12">
            <el-image style="width: 180px; height: 180px; flex-shrink:0 ;" :src="imgUrl" :preview-src-list="[imgUrl]"
              fit="contain">
            </el-image>
          </el-col>
          <el-col :span="12">
            <el-descriptions title="压缩信息" :column="1" v-if="compressResult.compressedSize">
              <el-descriptions-item label="压缩前">{{ getSizeTrans(compressResult.originalSize)
              }}</el-descriptions-item>
              <el-descriptions-item label="压缩后">{{ getSizeTrans(compressResult.compressedSize)
              }}</el-descriptions-item>
              <el-descriptions-item label="压缩率">{{ compressResult.rateString }}</el-descriptions-item>
              <el-descriptions-item label="减少">
                <el-tag size="small" type="success">
                  -{{ ((1 - compressResult.rate) * 100).toFixed(2) + '%' }}
                </el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin: 10px 0;">
        <el-button :disabled="!imgUrl" type="primary" @click="download">下载</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

// import TinyPNG from 'tinypng-lib'
import TinyPNG from 'tinypng-lib';
// import TinyPNG from '../../../dist';
import { getSizeTrans } from '../utils';


export default {
  name: 'Base',
  components: {
  },
  data() {
    return {
      imgUrl: '',
      imgName: '',
      compressResult: {},
      compressing: false,
      count: 0
    }
  },
  mounted() {
    // 计数器
    setInterval(() => {
      this.count++
    }, 500)
  },
  methods: {
    getSizeTrans,
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      return true
    },
    async uploadImg(e) {
      const file = e.file;
      this.imgName = e.file.name;
      try {
        this.compressing = true;
        const res = await TinyPNG.compress(file, {
          minimumQuality: 35,
          quality: 100
        })
        this.compressing = false;
        const url = URL.createObjectURL(res.blob)
        this.imgUrl = url;
        this.compressResult = res;
      } catch (error) {
        console.log("error", error)
      }

    },
    download() {
      const link = document.createElement('a');
      link.href = this.imgUrl;
      link.download = this.imgName; // 设置下载文件的名称
      link.click();
    },
  }
}
</script>